import { Directive, inject, Injector, input } from '@angular/core';
import { Chip } from '../filter-chips';
import { FILTER_CHIP_STRATEGY, FilterChipContext, FilterChipStrategy } from './filter-chip-context';

@Directive({
	standalone: true,
	host: {
		'[class.has-value]': 'ctx.hasValue()',
		'(insFooter)': 'onFooter()',
		'(insSelect)': 'onSelect($event)'
	}
})
export class FilterChipHostDirective {
	public readonly ctx = inject(FilterChipContext);
	readonly #injector = inject(Injector);

	public readonly chip = input<Chip>();

	get #strategy(): FilterChipStrategy {
		return this.#injector.get(FILTER_CHIP_STRATEGY);
	}

	public onFooter() {
		this.#strategy.resetDefaultValue();
	}

	public onSelect(event: Event) {
		const elm = event.target as HTMLInsSelectElement;

		const value = Array.isArray(elm.value)
			? elm.value.map(elem => this.ctx.converter.convertBack(elem))
			: this.ctx.converter.convertBack(elm.value);

		if (this.ctx.value() !== value || this.#strategy.chosenValues.includes(value)) {
			this.#strategy.onValueChange(value);
		}
	}
}
